import gql from 'graphql-tag';

const GET_ORDERS_COUNTERS_BY_WINDOW = gql`
    query getOrdersCountersByWindow ($filters: OrdersCountersByWindowInput) {
        getOrdersCountersByWindow (filters: $filters) {
            message
            status
            data {
                bySalesChannel {
                    info {
                        init
                        end
                        name
                        id
                        salesChannel
                        selectedSla
                        automaticAssign
                        cutOffTime
                        maximunCapacity
                        consumedCapacity
                        nameCarrier
                        category
                        time
                    },
                    data {
                        status
                        count
                    }
                }
            }
        }
    }
`;

export default GET_ORDERS_COUNTERS_BY_WINDOW;
